export default __webpack_public_path__ + "static/media/icon-campaignmanagement.7c478919.svg";